import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_accents_pots_plants: FaireCategoryEntity = {
  token: "cat_accents-pots-plants",
  type: "category",
  name: "Pots & plants",
  level: 3,
  parentToken: "cat_home-decor-accents",
  href: "/category/home-decor/home-accents/pots-plants",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
